import React from 'react';

import './SalesforceIcon.scss';

export const SalesforceIcon = () => (
	<img
		alt="Salesforce"
		className="salseforce-icon"
		src="data:image/svg+xml,%3Csvg%20class%3D%22size--large%22%20aria-hidden%3D%22true%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2052%2052%22%3E%3Cpath%20fill%3D%22%231b96ff%22%20d%3D%22M21.7%2C11.9c1.7-1.7%2C4-2.8%2C6.6-2.8c3.4%2C0%2C6.4%2C1.9%2C8%2C4.7c1.4-0.6%2C2.9-1%2C4.5-1C47%2C12.8%2C52%2C17.8%2C52%2C24%20s-5%2C11.2-11.2%2C11.2c-0.8%2C0-1.5-0.1-2.2-0.2c-1.4%2C2.5-4.1%2C4.2-7.2%2C4.2c-1.3%2C0-2.5-0.3-3.6-0.8c-1.4%2C3.3-4.7%2C5.6-8.6%2C5.6%20c-4%2C0-7.5-2.5-8.8-6.1c-0.6%2C0.1-1.2%2C0.2-1.8%2C0.2c-4.8%2C0-8.7-3.9-8.7-8.7c0-3.2%2C1.7-6%2C4.3-7.5c-0.5-1.2-0.8-2.6-0.8-4%20c0-5.5%2C4.5-10%2C10.1-10C17%2C8%2C19.9%2C9.5%2C21.7%2C11.9%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E"
	/>
);
